<template>
  <a-button type="primary" :disabled="initData.isEdit" @click="showModal"
    >新增奖项</a-button
  >
  <a-modal
    v-model:visible="visible"
    :title="title"
    @ok="handleOk"
    cancelText="取消"
    okText="确定"
    v-if="visible"
  >
    <a-radio-group
      @change="langCodeChange"
      style="margin-bottom: 14px !important;"
      v-model:value="subLangCode"
      v-if="initData?.langDic && initData?.langDic?.length"
    >
      <a-radio-button
        v-for="item in initData.langDic"
        :key="item.value"
        :value="item.value"
      >
        {{ item.label }}
      </a-radio-button>
    </a-radio-group>
    <a-form ref="formRef" :model="formState" :rules="rules" layout="vertical">
      <a-form-item label="获取方式类型" name="prizeType">
        <a-radio-group
          v-model:value="formState.prizeType"
          :disabled="isEdit === 'view' || notDefaultLang"
          @change="changeRadio"
        >
          <a-radio :value="1">优惠券</a-radio>
          <a-radio :value="2">积分</a-radio>
          <a-radio :value="3">谢谢参与</a-radio>
          <a-radio :value="4">自定义</a-radio>
          <a-radio :value="5">实物</a-radio>
        </a-radio-group>
      </a-form-item>
      <template v-if="formState.prizeType === 1">
        <a-form-item label="优惠券规则ID" name="discountRuleId">
          <a-input-number
            v-model:value="formState.discountRuleId"
            placeholder="请输入"
            :disabled="isEdit === 'view' || notDefaultLang"
            style="width: 100%;"
          />
        </a-form-item>
        <a-form-item label="优惠券有效期" name="validDays">
          <a-input-number
            v-model:value="formState.validDays"
            placeholder="请输入"
            :disabled="isEdit === 'view' || notDefaultLang"
            :min="0"
          />
          <span class="ml10">天</span>
        </a-form-item>
      </template>
      <template v-if="formState.prizeType === 2">
        <a-form-item label="积分发放场景ID" name="scenesId">
          <a-input-number
            v-model:value="formState.scenesId"
            :disabled="isEdit === 'view' || notDefaultLang"
            placeholder="请输入"
            :min="0"
            style="width: 100%;"
          />
        </a-form-item>
      </template>
      <span v-for="(item, index) in formState.langs" :key="index">
        <a-form-item
          label="奖项名称"
          :name="['langs', index, 'prizeName']"
          :rules="rules.prizeName"
          v-if="item.langCode === subLangCode"
        >
          <a-input
            v-model:value="item.prizeName"
            placeholder="请输入"
            show-count
            :maxlength="15"
            :disabled="isEdit === 'view'"
          />
        </a-form-item>

        <a-form-item
          label="图片"
          :name="['langs', index, 'imageUrl']"
          :rules="rules.imageUrl"
          :disabled="isEdit === 'view'"
          v-if="item.langCode === subLangCode"
        >
          <UploadCustom v-if="visible" v-model:imageUrl="item.imageUrl" />
        </a-form-item>
      </span>

      <a-form-item
        label="奖项SKC"
        name="skcCode"
        v-if="formState.prizeType === 5"
      >
        <a-input v-model:value="formState.skcCode" placeholder="请输入" />
      </a-form-item>
      <a-form-item
        label="领取有效期"
        name="acquireValidDays"
        v-if="formState.prizeType === 5"
      >
        中奖后
        <a-input-number
          v-model:value="formState.acquireValidDays"
          placeholder="请输入"
          class="ml10 mr10"
          :precision="0"
          :min="0"
        />天可领取
      </a-form-item>
      <a-form-item
        v-if="formState.prizeType === 2"
        label="中奖获取积分"
        name="point"
      >
        <a-input-number
          v-model:value="formState.point"
          placeholder="请输入"
          :disabled="isEdit === 'view' || notDefaultLang"
          :min="0"
        />
        <span class="ml10">积分</span>
      </a-form-item>
      <a-form-item name="probability">
        <template #label>
          <div>中奖概率<span class="tips">（支持小数点后两位）</span></div>
        </template>
        <a-input-number
          v-model:value="formState.probability"
          placeholder="请输入"
          :precision="2"
          :min="0"
          :max="100"
          :disabled="isEdit === 'view' || notDefaultLang"
        />
        <span class="ml10">%</span>
      </a-form-item>
      <a-form-item label="总库存" name="totalInventory">
        <div class="df aic">
          <template v-if="formState.totalInventory === -1">
            <a-input-number :disabled="true" />
          </template>
          <template v-else>
            <a-input-number
              v-model:value="formState.totalInventory"
              placeholder="请输入"
              show-count
              :min="0"
              :disabled="
                totalInventoryChecked || isEdit === 'view' || notDefaultLang
              "
            />
          </template>
          <a-form-item style="margin-bottom: 0;margin-left: 10px;">
            <a-checkbox
              v-model:checked="totalInventoryChecked"
              :disabled="
                isEdit === 'view' || notDefaultLang || formState.defaultPrize
              "
              @change="changeLimit(totalInventoryChecked, 'totalInventory')"
            >
              不限
            </a-checkbox>
          </a-form-item>
        </div>
      </a-form-item>
      <a-form-item label="单日库存" name="oneDayInventory">
        <div class="df aic">
          <template v-if="formState.oneDayInventory === -1">
            <a-input-number :disabled="true" />
          </template>
          <template v-else>
            <a-input-number
              v-model:value="formState.oneDayInventory"
              placeholder="请输入"
              show-count
              :min="0"
              :disabled="
                oneDayInventoryChecked || isEdit === 'view' || notDefaultLang
              "
            />
          </template>
          <a-form-item style="margin-bottom: 0;margin-left: 10px;">
            <a-checkbox
              v-model:checked="oneDayInventoryChecked"
              :disabled="
                isEdit === 'view' || notDefaultLang || formState.defaultPrize
              "
              @change="changeLimit(oneDayInventoryChecked, 'oneDayInventory')"
              >不限</a-checkbox
            >
          </a-form-item>
        </div>
      </a-form-item>
      <a-form-item label="用户活动获得上限" name="fetchUpperLimit">
        <div class="df aic">
          <template v-if="formState.fetchUpperLimit === -1">
            <a-input-number :disabled="true" />
          </template>
          <template v-else>
            <a-input-number
              v-model:value="formState.fetchUpperLimit"
              placeholder="请输入"
              show-count
              :min="0"
              :disabled="
                fetchUpperLimitChecked || isEdit === 'view' || notDefaultLang
              "
            />
          </template>
          <a-form-item style="margin-bottom: 0;margin-left: 10px;">
            <a-checkbox
              v-model:checked="fetchUpperLimitChecked"
              @change="changeLimit(fetchUpperLimitChecked, 'fetchUpperLimit')"
              :disabled="
                isEdit === 'view' || notDefaultLang || formState.defaultPrize
              "
              >不限</a-checkbox
            >
          </a-form-item>
        </div>
      </a-form-item>

      <a-form-item label="是否为兜底奖项" name="defaultPrize">
        <a-radio-group
          v-model:value="formState.defaultPrize"
          :disabled="isEdit === 'view' || notDefaultLang"
          @change="changeDefaultPrize(formState.defaultPrize)"
        >
          <a-radio :value="true">是</a-radio>
          <a-radio :value="false">否</a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item label="状态" name="status">
        <a-radio-group
          v-model:value="formState.status"
          :disabled="isEdit === 'view' || notDefaultLang"
        >
          <a-radio :value="1">启用</a-radio>
          <a-radio :value="2">禁用</a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item label="是否展示获奖记录" name="showRecord">
        <a-radio-group
          v-model:value="formState.showRecord"
          :disabled="isEdit === 'view' || notDefaultLang"
        >
          <a-radio :value="true">是</a-radio>
          <a-radio :value="false">否</a-radio>
        </a-radio-group>
      </a-form-item>
      <template v-if="[1, 2, 4].includes(formState.prizeType)">
        <a-form-item label="跳转链接-WEB" name="jumpUrlWeb">
          <a-input
            v-model:value="formState.jumpUrlWeb"
            placeholder="请输入"
            :disabled="isEdit === 'view' || notDefaultLang"
          />
        </a-form-item>
        <a-form-item label="跳转链接-APP" name="jumpUrlApp">
          <a-input
            v-model:value="formState.jumpUrlApp"
            placeholder="请输入"
            :disabled="isEdit === 'view' || notDefaultLang"
          />
        </a-form-item>
      </template>
    </a-form>
  </a-modal>
  <a-table
    :dataSource="initData.formState.lotteryPrizeDTOList"
    :columns="columns"
    :pagination="pagination"
    bordered
    class="mt20"
  >
    <template #bodyCell="{ column,index,text, record }">
      <template v-if="column.key === 'imageUrl'">
        <a-image
          :width="50"
          :src="record.imageUrl"
          :preview="false"
          fallback="data:image/png;base64,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"
        />
      </template>

      <template v-if="column.key === 'status'">
        <a-switch
          :checkedValue="1"
          :unCheckedValue="2"
          :disabled="initData.isEdit"
          v-model:checked="record.status"
        />
      </template>
      <template v-if="column.key === 'probability'">
        <span>{{ text }}%</span>
      </template>
      <template v-if="column.key === 'totalInventory'">
        <span>{{ text === -1 ? '不限' : text }}</span>
      </template>
      <template v-if="column.key === 'oneDayInventory'">
        <span>{{ text === -1 ? '不限' : text }}</span>
      </template>
      <template v-if="column.key === 'fetchUpperLimit'">
        <span>{{ text === -1 ? '不限' : text }}</span>
      </template>
      <template v-if="column.key === 'actions'">
        <a-button
          type="link"
          size="small"
          @click="handlePreview(record, 'view')"
          :disabled="initData.isEdit"
          >查看</a-button
        >
        <a-button
          type="link"
          size="small"
          @click="handlePreview(record, 'edit', index)"
          :disabled="initData.isEdit"
          >编辑</a-button
        >
        <a-button
          type="link"
          size="small"
          @click="handleDelete(index)"
          :disabled="initData.isEdit || isstatus - 0 === 2"
          >删除</a-button
        >
      </template>
    </template>
  </a-table>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import { reactive, toRefs, nextTick, inject, computed, watch } from 'vue'
import UploadCustom from './Upload.vue'
import { useCommon } from '../hooks/useCommon'
import { message } from 'ant-design-vue'
import { useRoute } from 'vue-router'

export default {
  name: 'AddAwards',
  components: { UploadCustom },
  setup() {
    const initData = inject('initData')
    const route = useRoute()
    const state = reactive({
      title: '新增奖项',
      formRef: null,
      formState: {
        prizeType: 1,
        defaultPrize: false,
        showRecord: false,
        status: 2,
        skcCode: null,
        acquireValidDays: null,
        langs: null
      },
      subLangCode: '',
      isstatus: route.query.status || '',
      labelCol: { span: 4 },
      wrapperCol: { span: 16 },
      visible: false,
      langCodeChange() {
        state.formRef.clearValidate()
      },
      notDefaultLang: computed(
        () => state.subLangCode !== initData.defaultLanguageCode
      ),
      resetData: form => ({
        prizeName: form?.prizeName ?? '',
        imageUrl: form?.imageUrl ?? ''
      }),
      showModal() {
        state.visible = true
        state.isEdit = 'add'
        nextTick(() => {
          state.formState.langs = null
          state.formState = {
            prizeType: 1,
            defaultPrize: false,
            showRecord: false,
            status: 2,
            langs: initData.handleLangsLack(
              state.formState.langs,
              state.resetData()
            )
          }
          state.startWatch()
          state.totalInventoryChecked = false
          state.oneDayInventoryChecked = false
          state.fetchUpperLimitChecked = false

          state.subLangCode = initData.defaultLanguageCode

          state.formRef.clearValidate()
        })
      },
      startWatch() {
        const unwatch = watch(
          () => JSON.parse(JSON.stringify(state.formState.langs)),
          (n, o) => {
            const currentLangIndex = state.formState.langs.findIndex(
              v => v.langCode === state.subLangCode
            )
            if (state.subLangCode === initData.defaultLanguageCode) {
              state.formState.langs.forEach(item => {
                if (!item?.notPrizeNamefollow) {
                  item.prizeName = n[currentLangIndex].prizeName
                }
                if (!item?.notImageUrlfollow) {
                  item.imageUrl = n[currentLangIndex].imageUrl
                }
              })
            } else {
              if (
                n?.[currentLangIndex]?.prizeName !==
                  o?.[currentLangIndex]?.prizeName &&
                state.subLangCode
              ) {
                state.formState.langs[
                  currentLangIndex
                ].notPrizeNamefollow = true
              }
              if (
                n?.[currentLangIndex]?.imageUrl !==
                  o?.[currentLangIndex]?.imageUrl &&
                state.subLangCode
              ) {
                state.formState.langs[currentLangIndex].notImageUrlfollow = true
              }
            }
          },
          {
            deep: true
          }
        )
        return unwatch
      },
      async handleOk() {
        if (state.isEdit === 'view') {
          state.visible = false
          return
        }
        try {
          await state.formRef.validateFields()
          if (!state.totalInventoryChecked) {
            if (
              state.formState.oneDayInventory > state.formState.totalInventory
            ) {
              message.warn('单日库存需小于等于总库存')
              return false
            }
          }

          let flag = true
          for (let v of state.formState?.langs) {
            if (!v.prizeName || !v.imageUrl) {
              message.error(
                `多语言${
                  initData.langDic.find(k => k.value === v.langCode)?.label
                }下${!v.prizeName ? '奖项名称' : '图片'}不能为空`
              )
              flag = false
              break
            }
          }

          if (!flag) throw { flag }

          state.visible = false
          if (state.isEdit === 'add') {
            const data = JSON.parse(
              JSON.stringify({
                ...state.formState,
                ...state.formState?.langs?.[initData.defaultLanguageIndex]
              })
            )
            initData.formState.lotteryPrizeDTOList.unshift(data)
          } else {
            const data = JSON.parse(
              JSON.stringify({
                ...state.formState,
                ...state.formState?.langs?.[initData.defaultLanguageIndex]
              })
            )
            initData.formState.lotteryPrizeDTOList[state.rowIndex] = data
          }
        } catch (errorInfo) {
          console.log('Failed:', errorInfo)
        }
      },
      changeLimit(isTrue, type) {
        state.formState[type] = isTrue ? -1 : ''
        state.formRef.clearValidate([type])
      },
      changeDefaultPrize(isTrue) {
        state.totalInventoryChecked = isTrue
        state.oneDayInventoryChecked = isTrue
        state.fetchUpperLimitChecked = isTrue
        state.formState.totalInventory = isTrue ? -1 : ''
        state.formState.oneDayInventory = isTrue ? -1 : ''
        state.formState.fetchUpperLimit = isTrue ? -1 : ''
        nextTick(() => {
          state.formRef.clearValidate([
            'totalInventory',
            'oneDayInventory',
            'fetchUpperLimit'
          ])
        })
      },

      handlePreview(record, isEdit = 'edit', index = null) {
        state.totalInventoryChecked = record.totalInventory === -1
        state.oneDayInventoryChecked = record.oneDayInventory === -1
        state.fetchUpperLimitChecked = record.fetchUpperLimit === -1
        state.formState = JSON.parse(
          JSON.stringify({
            ...record,
            langs: initData.handleLangsLack(
              record?.langs,
              state.resetData(),
              state.resetData(record)
            )
          })
        )
        state.subLangCode = initData.defaultLanguageCode
        state.visible = true
        if (record.defaultPrize) {
          state.changeDefaultPrize(record.defaultPrize)
        }
        if (typeof record.status === Boolean) {
          state.formState.status = record.status ? 1 : 2
        }

        state.isEdit = isEdit
        state.rowIndex = index
      },
      handleDelete(index) {
        initData.formState.lotteryPrizeDTOList.splice(index, 1)
      },
      rowIndex: null,
      isEdit: 'add',
      ...useCommon(),
      dataSource: [],
      pagination: {},
      totalInventoryChecked: false,
      oneDayInventoryChecked: false,
      fetchUpperLimitChecked: false,
      changeRadio: e => {
        if (e.target.value !== 5) {
          state.formState.skcCode = null
          state.formState.acquireValidDays = null
        }
      }
    })

    return {
      ...toRefs(state),
      initData
    }
  }
}
</script>
<style lang="scss" scoped>
.tips {
  font-size: 12px;
  padding-left: 6px;
  color: rgba(0, 0, 0, 0.3);
}
</style>
